import React from 'react';
import classNames from 'classnames';
import styles from './Checkbox.module.less';

export default ({
  handleChange,
  children,
  checked,
  checkboxStyle = {},
  iconStyle,
  primary,
  className,
}) => {
  const handleClick = () => {
    if (handleChange) {
      handleChange();
    }
  };
  return (
    <div className={styles.checkbox} onClick={handleClick} style={checkboxStyle}>
      <i
        className={classNames(
          { 'icon-checkbox': !checked && !primary },
          { 'icon-checkbox_primary': !checked && primary },
          { 'icon-checkbox_active': checked && !primary },
          { 'icon-checkbox_primary_active': checked && primary },
          'iconfont',
          styles.checkbox_box,
          {
            [styles.active]: checked && !primary,
          },
          className,
        )}
        style={iconStyle}
      ></i>
      {children}
    </div>
  );
};
